import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { TopnavService } from '../header/topnav/topnav.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Http, Response } from '@angular/http';
import { FaqService } from './faq.service';
import { SharedService } from '../common/shared.service';
import { Title } from '@angular/platform-browser';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for FAQ Content - /faq
 **/
@Component({
     templateUrl: 'faq.component.html',
     styles: [`
     a {
            color: #337ab7;
            text-decoration: none;
      }
      a:hover, a:focus {
        color: #1ebebc;
        text-decoration: underline;
      }
     `
     ],
     providers: [FaqService]
})

export class FaqComponent implements OnInit, AfterViewInit, OnDestroy{
  lang; // = this.lang;
  langID: any;
  faqData = null;
  faqList = [];
  openFlag = false;
  faqAnswer: any;
  faqQuestion: any;
  private subscriptionLang: ISubscription;
  private subscription: ISubscription;
  public subscriptionFontType: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
      "sizeS" : "14px",
      "sizeM" : "19px",
      "sizeL" : "23px",
      "no_styles" : "0.9em"
  };
  public fontType: string = 'Arial'; 

  private urlFaq: string = this.config.urlFaq;
  loading: boolean = false;
  public myflag: any;

  constructor(
      private activatedRoute: ActivatedRoute,
      private pageTitle: Title,
      private sharedService: SharedService,
      private translate: TranslateService,
      private http: Http,
      @Inject(APP_CONFIG) private config: AppConfig,
      private topnavservice: TopnavService) {

      this.lang = this.translate.currentLang;

      this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

          const myLang = translate.currentLang;

          if (myLang == 'en') {

              translate.get('HOME').subscribe((res: any) => {
                  this.lang = 'en';
                  this.langID = 1;
                  //this.getFaq(this.langID);
              });
          }

          if (myLang == 'ms') {

              translate.get('HOME').subscribe((res: any) => {
                  this.lang = 'ms';
                  this.langID = 2;
                  //this.getFaq(this.langID);
              });
          }

          if(this.topnavservice.flagLang){
            //this.getSlide(this.languageId);
            this.subscription = this.getFaq(this.langID);
          }

      });

      this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
        this.fontSize = data;
      });
  
      this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
        this.fontType = data;
      });

      this.activatedRoute.queryParams.subscribe(params => {
        let lng = params['language'];
        if (lng && lng.toLowerCase() == 'my') {
          this.myflag = {language:"my"};
          this.translate.setDefaultLang('ms');
          this.translate.use('ms');
        } else {
          this.myflag = null;
        } 
      });
  
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscription.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  ngOnInit() {
    // this.langID = 0;
    // if (this.lang === 'ms') {
    //   this.langID = 2;
    // }else {
    //   this.langID = 1;
    // }

    if(!this.langID){
      if (localStorage.getItem('langID')) {
        this.langID = localStorage.getItem('langID');
      } else {
        this.langID = 1;    
      }
    }
    this.subscription = this.getFaq(this.langID);
  }

  ngAfterViewInit() {
   
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title + this.translate.instant('home.menu.faq');
      this.sharedService.setTitleAndGtag(title);
    }); 
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  }

  openAnswer(sequence, flag) {
    
    if (this.faqList[sequence].faqOpenFlag == flag) {
      this.faqList[sequence].faqOpenFlag = false;
    } else {
      this.faqList[sequence].faqOpenFlag = true;
    }
    
  }

  getTheme() {
    return '1px solid #2b3e50';
    /* return '1px solid ' + localStorage.getItem('themeColor'); */
  }

  getFaq(lang) {
    this.loading = true;

    return this.http.get(this.urlFaq + '?language=' + lang + '&page=1&size=99')

    .map((response: Response) => response.json())
    .subscribe(resSliderData => {
      this.faqData = resSliderData
      this.faqList = this.faqData['faqList'];
      
      for (let i=0; i<this.faqList.length; i++) {
        this.faqList[i]['faqOpenFlag'] = false;
      }
      
      this.loading = false;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/staticpage/faq.component.ts